import { render, staticRenderFns } from "./DismissOrgDialog.vue?vue&type=template&id=0014a907&scoped=true"
import script from "./DismissOrgDialog.vue?vue&type=script&lang=js"
export * from "./DismissOrgDialog.vue?vue&type=script&lang=js"
import style0 from "./DismissOrgDialog.vue?vue&type=style&index=0&id=0014a907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0014a907",
  null
  
)

export default component.exports